export default __webpack_public_path__ + "static/media/43.ef328d17.png";